export default {"src":"/_next/static/media/flag-MX.54efba3c.svg","height":18,"width":24,"blurWidth":0,"blurHeight":0};